import { Tooltip } from 'antd';
import React, { FC, useState } from 'react';

interface FilterOptionLabelProps {
  label: string;
  children: React.ReactNode;
  initiallyOpen?: boolean;
  icon?: React.ReactNode;
  iconHandler?: () => void;
  iconToolTipText?: string;
}

const FilterOptionLabel: FC<FilterOptionLabelProps> = (props) => {
  const [isOpen, setIsOpen] = useState(props?.initiallyOpen); // State to control visibility

  const toggleCollapse = () => {
    setIsOpen(!isOpen); // Toggle visibility
  };

  return (
    <div className="FilterOptionLabel" style={{ marginTop: '10px' }}>
      <div className="flex">
        <button
          className="filterHeading"
          onClick={toggleCollapse}
          style={{
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            background: 'none',
            border: 'none',
            padding: 0,
            outline: 'none', // Remove default focus outline
          }}
          onFocus={(e) => (e.currentTarget.style.boxShadow = '0 0 0 0px #1890ff')} // Add custom focus style
          onBlur={(e) => (e.currentTarget.style.boxShadow = 'none')} // Remove custom focus style on blur
          aria-expanded={isOpen}
          aria-label={props?.label}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') toggleCollapse();
          }}
        >
          <span style={{ marginRight: '10px', fontWeight: 'bold' }}>{isOpen ? '-' : '+'}</span>
          <p style={{ margin: 0 }}>{props?.label}</p>
        </button>
        {props?.icon && (
          <button
            className="ml-5 cursor-pointer"
            onClick={props?.iconHandler}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              outline: 'none', // Remove default focus outline
            }}
            onFocus={(e) => (e.currentTarget.style.boxShadow = '0 0 0 2px #1890ff')} // Add custom focus style
            onBlur={(e) => (e.currentTarget.style.boxShadow = 'none')} // Remove custom focus style on blur
          >
            <Tooltip placement="rightTop" title={props?.iconToolTipText}>
              {props?.icon}
            </Tooltip>
          </button>
        )}
      </div>
      {isOpen && (
        <div className="filterBox" style={{ marginTop: '10px', display: 'flex', flexDirection: 'column' }}>
          {props?.children}
        </div>
      )}
    </div>
  );
};

export default FilterOptionLabel;
